import { useLocation } from 'react-router-dom'

import { Text } from '@reveni-io/reveni-ui'

import routes from '@/Router/routes.constants'

import * as Styles from './styles'

const ParcelName = ({ parcel }) => {
  const location = useLocation()

  return (
    <Styles.ParcelNameLink to={routes.parcelDetailPage.replace(':id', parcel?.id)} state={{ from: location }}>
      <Text type="linkM">{parcel?.order?.name}</Text>
    </Styles.ParcelNameLink>
  )
}

export default ParcelName
